/** Empty state for shadcn tables.
 *
 *  Not CuoEmpty: that is still MUI, and its Grid sets height 100% which does
 *  not resolve inside a td, so it pinned to the top of a tall cell anyway.
 */
export default function TableEmpty({
  icon: Icon,
  text,
}: {
  icon: React.ComponentType<{ className?: string }>;
  text: string;
}) {
  return (
    <div className="flex h-full min-h-[200px] flex-col items-center justify-center gap-2 p-6 text-center">
      <Icon className="size-7 text-muted-foreground/40" />
      <p className="m-0 text-[12.5px] text-muted-foreground">{text}</p>
    </div>
  );
}
